import React from 'react';
import RateMicroGraph from './RateMicroGraph';
import { planningGraphColorValues, planningGraphLabels } from '../Constants/PlanningGraphColors';

// One bar showing how far a planning row has got, from what is still unassigned through to
// what has been invoiced. Every planning level — service, country and fieldwork period —
// carries the same six counts and drew the same graph from its own copy of this arithmetic.
// The service level is the one that names its planned volume differently, so it hands the
// count in rather than this component guessing at a second field name.
export default function PlanningProgressGraph({ item, plannedCount = null }) {
  const planned = plannedCount === null ? item.NumberOfPlannedAssignments : plannedCount;
  if (planned <= 0) {
    return null;
  }

  const numbers = [
    // Not assigned
    planned - item.NumberOfAssignmentsAll,
    // Assigned but not completed
    item.NumberOfAssignmentsAll - item.NumberOfAssignmentsCompleted,
    // Completed but not finalized
    item.NumberOfAssignmentsCompleted - item.NumberOfAssignmentsFinalized,
    // Finalized but not invoiced
    item.NumberOfAssignmentsFinalized - item.NumberOfAssignmentsInvoiced,
    // Invoiced
    item.NumberOfAssignmentsInvoiced,
    // Excluded
    item.NumberOfAssignmentsExcluded,
  ];

  return (
    <RateMicroGraph
      numbers={numbers}
      colors={planningGraphColorValues}
      names={planningGraphLabels}
    />
  );
}
